import { NgModule } from "@angular/core";
import { BoxBackend } from "./api/box/box.backend";
import { RequestBackend } from "./api/request/request.backend";
import { StudyBackend } from "./api/study/study.backend";
import { DeviceBackend } from "./api/device/device.backend";
import { BackupBackend } from "./api/backup/backup.backend";
import { ArchiveBackend } from "src/app/modules/bootstrap/rocket-ui/backend/api/archive.backend";
import { WorklistBackend } from "./api/request/worklist.backend";

@NgModule({
  imports: [],
  providers: [
    StudyBackend,
    ArchiveBackend,
    RequestBackend,
    WorklistBackend,
    BackupBackend,
    BoxBackend,
    DeviceBackend
  ]
})
export class RocketBackendModule {}
